import type {EnterpriseSpaceNote} from '../../../common/clientPageLayout.js';
import {escapeHtml} from '../../layout.js';

/**
 * 把自定义说明渲染成所属团队页上的提示块。
 * @param notes 已经按身份筛过的说明
 */
export function enterpriseSpaceNoteMarkup(notes: EnterpriseSpaceNote[]): string {
  return notes.map((note) => `<aside class="enterprise-page-note">${note.title ? `<strong>${escapeHtml(note.title)}</strong>` : ''}${note.body ? `<p>${escapeHtml(note.body)}</p>` : ''}</aside>`).join('');
}
